import React, { useEffect, useState } from "react";
import Sec1Main from "./Section1/Sec1Main";
import Section2Main from "./Section2/Section2Main";
import ShopInfosection1 from "./ShopInfosection1";
import Newsletter from "../NEWSLETTER/Newsletter";
import SetLoader from "../loader/SetLoader";



const ShopMain = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth"

    });
    const loadingTimeout = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(loadingTimeout);
  }, []);
  return (

    <div>
      {loading ? (
        <div className="flex justify-center items-center my-56" >
          <SetLoader />
        </div>
      ) : (
        <div>
          
          <div className=" mt-5 shopmain">
            <ShopInfosection1 />
          </div>
          <div className="mt-5">
            <Sec1Main />
            <Section2Main />
            <Newsletter />
          </div>
        </div>
      )}
    </div>

  );
};

export default ShopMain;
